export const METRICS_ADVERTISER = [
  {
    colName: 'installs',
    label: 'Installs',
  },
  {
    colName: 'cr',
    label: 'Convertion rate',
  },
  {
    colName: 'impressions',
    label: 'Impressions',
  },
  {
    colName: 'clicks',
    label: 'Clicks',
  },
  {
    colName: 'cost',
    label: 'Cost',
  },
];

export const METRICS_PUBLISHER = [
  {
    colName: 'eCPM',
    label: 'eCPM',
  },
  {
    colName: 'revenue',
    label: 'Revenue',
  },
];

// MOCK DATA (remove after endpoints are ready)

// Performance Breakdown blocks ADVERTISED
// TO-DO unite campaigns, event ratios and events ?

export const APPLICATION_BLOCK = [
  {
    id: 503397,
    app_name: 'Beauty Empire',
    image: 'app_img_b03ffa84-735d-4fba-ad00-a232b09e3e30.png',
    metrics: {
      installs: { value: 16720, trend: 'down' },
      cost: { value: 4160000, trend: 'up' },
    },
  },
  {
    id: 503398,
    app_name: 'Township',
    image: 'app_img_b03ffa84-735d-4fba-ad00-a232b09e3e30.png',
    metrics: {
      installs: { value: 15480, trend: 'down' },
      cost: { value: 3280000, trend: 'down' },
    },
  },
];

export const CAMPAIGNS_BLOCK = [
  {
    id: 503397,
    cm_name: 'Beauty Empire',
    image: 'app_img_b03ffa84-735d-4fba-ad00-a232b09e3e30.png',
    status: 2,
    metrics: {
      installs: { value: 16720, trend: 'down' },
      cost: { value: 4160000, trend: 'up' },
    },
  },
  {
    id: 503398,
    cm_name: 'Township',
    image: 'app_img_b03ffa84-735d-4fba-ad00-a232b09e3e30.png',
    status: 2,
    metrics: {
      installs: { value: 15480, trend: 'down' },
      cost: { value: 3280000, trend: 'down' },
    },
  },
];

export const EVENTS_RATIO_BLOCK = [
  {
    id: 503397,
    cm_name: 'Beauty Empire',
    image: 'app_img_b03ffa84-735d-4fba-ad00-a232b09e3e30.png',
    status: 2,
    metrics: {
      installs: { value: 15480, trend: 'down' },
      cost: { value: 3280000, trend: 'down' },
    },
    events: {
      purchase: { value: 16720, trend: 'down' },
      ['app opened']: { value: 4160000, trend: 'up' },
    },
  },
];
